import React, {ReactNode, useEffect} from 'react';

import {Analytics} from '../../services/analytics';
import {EventData} from '../../services/analytics/types';
import {BANNER_VARIANTS, BannerVariant, BannerWrapper} from './Banner.styles';

type Props = {
  variant?: BannerVariant;
  eventData?: EventData;
  children?: ReactNode;
};

export const Banner = ({
  variant = BANNER_VARIANTS.INFO,
  eventData,
  children,
  ...props
}: Props) => {
  useEffect(() => {
    Analytics.track('Banner Viewed', eventData ?? {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BannerWrapper variant={variant} {...props}>
      {children}
    </BannerWrapper>
  );
};
